import {
  jb_article_tool_bar_css_default
} from "./chunk.5JFBY6PA.js";
import {
  Spaceable
} from "./chunk.3FKBYJ4V.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-article-tool-bar/jb-article-tool-bar.ts
var JbArticleToolBar = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return { grid: "legacy", type: "article-toolbar" };
  }
  _handleClick(evt, icon) {
    if (icon === "jb-mail-icon") {
      this.dispatchEvent(
        new CustomEvent("jbNewsletterOverlayPopupOpen", {
          bubbles: true,
          composed: true,
          detail: {
            returnFocusTo: evt.target
          }
        })
      );
    }
  }
  render() {
    return ke`
      <jb-article-share-bar
        .articleTitle=${this.articleTitle}
        .mailSubject=${this.mailSubject}
        .shareServices=${this.shareServices}
        .title=${this.shareBarLabel}
        .url=${this.url}
      ></jb-article-share-bar>
      <jb-button-panel>
        ${this.buttons.map(
      (item) => ke`
            <jb-button-secondary @click=${(evt) => this._handleClick(evt, item.icon)}>
              ${item.icon === "jb-mail-icon" ? ke`<jb-mail-icon></jb-mail-icon>` : D}
              ${item.label}</jb-button-secondary
            >
          `
    )}
      </jb-button-panel>
    `;
  }
};
JbArticleToolBar.styles = [reset_css_default, jb_article_tool_bar_css_default];
__decorateClass([
  n()
], JbArticleToolBar.prototype, "articleTitle", 2);
__decorateClass([
  n({ type: Array })
], JbArticleToolBar.prototype, "buttons", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "mailSubject", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "shareBarLabel", 2);
__decorateClass([
  n({ type: Array })
], JbArticleToolBar.prototype, "shareServices", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "url", 2);
JbArticleToolBar = __decorateClass([
  customElement("jb-article-tool-bar")
], JbArticleToolBar);

export {
  JbArticleToolBar
};
